import handleInputMask from './handleInputMask';

function Handler() {
  // nothing
}

/**
 * 限制交互
 */
Handler.limit = function () {
  // 记录
  var _O = {};
  /**
   * 对应tag标记限制交互
   * @param {String} tag 限制开启时的标记
   * @param {Number} time 限制时间单位秒s 0时永久限制，通过limit.off方法解除
   * @returns {Boolean} 是否已被限制
   */
  var h = function (tag, time) {
    tag = tag || 'default';
    time = typeof time === 'number' ? time : 1;
    tag = `__limit__${tag}`;
    if (_O[tag]) return true;
    if (time === 0) {
      _O[tag] = true;
    } else {
      _O[tag] = setTimeout(() => {
        _O[tag] = ''[0];
      }, time * 1000);
    }
  };
  /**
   * 对应tag标记限制被解除，用户可交互
   * @param {String} tag 解除限制的标记
   */
  h.off = (tag) => {
    tag = tag || 'default';
    tag = `__limit__${tag}`;
    clearTimeout(_O[tag]);
    _O[tag] = ''[0];
  };
  return h;
};
Handler.limit.install = function (Vue) {
  Vue.mixin({
    created() {
      this.$limit = Handler.limit();
    }
  });
};

Handler.handleInputMask = handleInputMask;

export default Handler;



// WEBPACK FOOTER //
// ./src/utils/handler/index.js